import React from "react";
import "./Podcast.css";
import { podcastSection } from "../../portfolio";
import { Fade } from "react-reveal";

export default function Podcast() {
  if (!podcastSection.podcast || podcastSection.podcast.length === 0)
    return null;
  return (
    <div className="main">
      <div className="podcast-header">
        <Fade bottom duration={1000} distance="20px">
          <h1 className="podcast-header-title">{podcastSection.title}</h1>
          <p className="subTitle podcast-header-subtitle">
            {podcastSection.subtitle}
          </p>
        </Fade>
      </div>
      <div className="podcast-main-div">
        {podcastSection.podcast.map((podcastLink) => {
          return (
            <div>
              <iframe
                title="podcast"
                className="podcast"
                src={podcastLink}
                frameborder="0"
                scrolling="no"
              ></iframe>
            </div>
          );
        })}
      </div>
    </div>
  );
}
